import React from 'react';
import Sidebar from '../components/ui-components/Sidebar';
import { motion } from 'framer-motion';
import { useMediaQuery } from '@/hooks/use-media-query';
import { cn } from '@/lib/utils';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className="fixed inset-0 bg-background overflow-hidden">
      <Sidebar />
      <motion.main 
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        className={cn(
          "h-full overflow-y-auto transition-all duration-300 relative",
          "overscroll-behavior-y-contain -webkit-overflow-scrolling-touch",
          isMobile ? "p-4" : "p-8 ml-[80px] md:ml-[256px]"
        )}
      >
        <div className="min-h-full">
          {children}
        </div>
      </motion.main>
    </div>
  );
};

export default DashboardLayout; 